'use client'

import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import { useProductData } from '@/components/ProductData/ProductDataProvider'
import { useCartEntryToReplace } from '@/components/ProductPage/useCartEntryToReplace'
import { PurchaseSummary } from '@/features/priceCalculator/PurchaseFormV2/PurchaseSummary/PurchaseSummary'
import { useTracking } from '@/services/Tracking/useTracking'
import { useResponsiveVariant } from '@/utils/useResponsiveVariant'
import { ProductHeroPillow } from '../../ProductHeroV2/ProductHeroPillow/ProductHeroPillow'
import { StickyProductHeader } from '../../ProductHeroV2/StickyProductHeader/StickyProductHeader'
import { ProductSpecs } from '../../ProductSpecs/ProductSpecs'
import { priceCalculatorAddedOffer } from '../../PurchaseFormV2/priceCalculatorAtoms'
import { PurchaseFormV2 } from '../../PurchaseFormV2/PurchaseFormV2'
import { usePriceIntent } from '../../usePriceIntent'
import { CartToast } from './CartToast/CartToast'
import {
  pageGrid,
  priceCalculatorSection,
  purchaseSummaryWrapper,
  purchaseSummary,
  productHeroSection,
} from './PriceCalculatorCmsPageContent.css'

export function PriceCalculatorCmsPageContent() {
  useReportOpenPriceCalculator()

  const variant = useResponsiveVariant('lg')
  const addedOfferToCart = useAtomValue(priceCalculatorAddedOffer)
  const entryToReplace = useCartEntryToReplace()

  const { priceIntent } = usePriceIntent(entryToReplace?.priceIntentId)

  const [isCondensed, setIsCondensed] = useState(false)

  const showProductHero = variant === 'desktop' || !addedOfferToCart
  // Hide some of the header menu items and show a back button
  // to product page, except when an offer is added to cart
  const hideHeaderMenu = !addedOfferToCart

  return (
    <main className={pageGrid} data-hide-header-menu={hideHeaderMenu}>
      {showProductHero && (
        <section className={productHeroSection}>
          {priceIntent && <StickyProductHeader setIsCondensed={setIsCondensed} />}
          <ProductHeroPillow isCondensed={isCondensed} />
          {variant === 'desktop' && <ProductSpecs />}
        </section>
      )}

      <section className={priceCalculatorSection}>
        {addedOfferToCart && (
          <div className={purchaseSummaryWrapper}>
            <PurchaseSummary className={purchaseSummary} />
          </div>
        )}

        {!addedOfferToCart && <PurchaseFormV2 />}
      </section>

      {/* We don't mount CartToast on mobile as we hide ShoppingCartMenuItem at that level */}
      {variant === 'desktop' && <CartToast />}
    </main>
  )
}

function useReportOpenPriceCalculator() {
  const tracking = useTracking()
  const productData = useProductData()

  useEffect(() => {
    tracking.reportOpenPriceCalculator({
      id: productData.id,
      displayNameFull: productData.displayNameFull,
    })
  }, [tracking, productData])
}
